import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "privacy-overlay" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_control_checkbox = _resolveComponent("control-checkbox")!
  const _component_button_save = _resolveComponent("button-save")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"]))
    }, [
      _createVNode(_component_control_checkbox, {
        i18nLabel: "common.privacyNotice",
        validation: _ctx.v$.privacyNotice,
        modelValue: _ctx.privacyNotice,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.privacyNotice) = $event)),
        forCaptcha: true
      }, null, 8, ["validation", "modelValue"]),
      _createVNode(_component_button_save, { i18nMessage: "common.privacyNoticeButton" })
    ], 32)
  ]))
}